module.exports = __webpack_public_path__ + "static/media/Messenger.e0e6bb0f.svg";